export default function TermsOfUse() {
    return <div className="flex flex-col gap-2 p-1">
        <h4 className="text-md">
            Bem-vindo ao Cofrim! <br />
            Estes Termos de Uso estabelecem as regras e condições para o uso de nossa plataforma de gestão financeira pessoal. Ao acessar ou usar nossos serviços, você concorda em cumprir estes termos.
        </h4>
        
        <h4 className="text-md">
            <b>1. Aceitação dos Termos:</b> Ao criar uma conta no Cofrim, você confirma que leu, compreendeu e concorda em cumprir estes Termos de Uso e nossa Política de Privacidade. Se você não concordar com qualquer parte destes termos, não deve usar nossos serviços.
        </h4>
        
        <h4 className="text-md">
            <b>2. Descrição do Serviço:</b> O Cofrim é uma plataforma digital que oferece ferramentas para gestão financeira pessoal, incluindo controle de gastos, orçamentos, planejamento de metas financeiras e conteúdo educacional sobre finanças.
        </h4>
        
        <h4 className="text-md">
            <b>3. Responsabilidades do Usuário:</b>
        </h4>
        <h4 className="text-md">
            • Fornecer informações precisas e atualizadas durante o cadastro;<br />
            • Manter a confidencialidade de suas credenciais de acesso;<br />
            • Usar a plataforma apenas para fins legais e de acordo com estes termos;<br />
            • Não compartilhar sua conta com terceiros;<br />
            • Notificar-nos imediatamente sobre qualquer uso não autorizado de sua conta.
        </h4>
        
        <h4 className="text-md">
            <b>4. Propriedade Intelectual:</b> Todo o conteúdo disponível na plataforma Cofrim, incluindo textos, gráficos, logotipos, ícones, imagens, clipes de áudio, downloads digitais e software, é propriedade exclusiva do Cofrim e está protegido por leis de direitos autorais e marcas registradas.
        </h4>
        
        <h4 className="text-md">
            <b>5. Pagamentos e Assinaturas:</b>
        </h4>
        <h4 className="text-md">
            • Os valores das assinaturas são apresentados claramente antes da contratação;<br />
            • Oferecemos 7 dias grátis antes do primeiro pagamento;<br />
            • O pagamento é processado mensalmente após o período gratuito, conforme o plano escolhido;<br />
            • Você pode cancelar sua assinatura a qualquer momento através da plataforma;<br />
            • Ao cancelar após o pagamento, você manterá acesso completo à plataforma pelo período já pago, sem reembolso proporcional.
        </h4>
        
        <h4 className="text-md">
            <b>6. Limitação de Responsabilidade:</b> O Cofrim fornece ferramentas e informações para auxiliar na gestão financeira pessoal, mas não oferece aconselhamento financeiro profissional. As decisões financeiras tomadas com base nas informações fornecidas são de sua exclusiva responsabilidade.
        </h4>
        
        <h4 className="text-md">
            <b>7. Proteção de Dados:</b> Levamos a segurança de seus dados financeiros muito a sério. Utilizamos criptografia de nível bancário e seguimos as melhores práticas de segurança da informação. Para mais detalhes, consulte nossa Política de Privacidade.
        </h4>
        
        <h4 className="text-md">
            <b>8. Rescisão:</b> Reservamo-nos o direito de suspender ou encerrar sua conta caso haja violação destes termos. Você pode cancelar seu plano a qualquer momento através da página de perfil da plataforma.
        </h4>
        
        <h4 className="text-md">
            <b>9. Modificações dos Termos:</b> Podemos atualizar estes Termos de Uso periodicamente. Quando isso ocorrer, notificaremos você por e-mail ou através de um aviso na plataforma. O uso continuado dos serviços após as modificações constitui aceitação dos novos termos.
        </h4>
        
        <h4 className="text-md">
            <b>10. Lei Aplicável:</b> Estes termos são regidos pelas leis brasileiras. Qualquer disputa será resolvida nos tribunais competentes do Brasil.
        </h4>
        
        <h4 className="text-md">
            <b>11. Contato:</b> Se você tiver dúvidas sobre estes Termos de Uso, entre em contato conosco pelo e-mail <span className="text-blue-800">contato@cofrim.com.br</span>.
        </h4>
        
        <h4 className="text-md">
            <b>Data da última atualização:</b> {new Date().toLocaleDateString('pt-BR')}
        </h4>
    </div>
}